import React, { createContext, useContext } from "react";
import { toast } from "react-toastify";
import { CustomSnackbar } from "./../components/common";
import { mergeAppToastOptions } from "../components/common/CustomSnackbar";
import { ParagraphText } from "../Libraries";
import { sentenceCase } from "../constants";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const showSnackbar = ({
    message,
    severity = "info",
    icon,
    duration = 3000,
    toastId,
    position: positionOverride,
    className,
    bodyClassName,
  }) => {
    const position = positionOverride || "bottom-center";
    toast(
      <ParagraphText className={"fontWeight500 fontSize14 newFontColor textAlignLeft"}>
        {sentenceCase(message)}
      </ParagraphText>,
      mergeAppToastOptions({
        autoClose: duration,
        position,
        icon,
        type: severity,
        toastId: toastId || "toastId",
        className,
        bodyClassName,
      }),
    );
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      <CustomSnackbar />
    </SnackbarContext.Provider>
  );
};
